<template>
  <CFooter class="d-flex flex-column justify-content-center">
    <div>
      KIIS Feeder Institut Bisnis dan Informatika Kesatuan Bogor
      <span class="ms-1">&copy; {{ new Date().getFullYear() }}</span>
    </div>
    <div class="text-primary">IBI Kesatuan</div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
